import AppConstants from "./AppConstants";

const TextConstantTip ={
  USER_TYPE: "User Type",
  VENDOR: "Vendor",
  NAME: "Name",
  ID: "ID",
  ORDER_ID: "Order ID",
  CONSIGNMENT_ID: "Consignment ID",
  DELIVERY_DATE: "Delivery Date",
  TOTAL_ORDER_TIP: "Total Order Tip",
  TIP_SHARE: "Tip Share",
  TOTAL_ORDER_AMOUNT: "Total Order Amount",
  STATUS: "Status",
  STORE_NAME: "Store Name",
  STORE_ID: "Store ID",
  DELIVERED_BY: "Delivered By",
  PREPARED_BY: "Prepared By",
  DRIVER: "Driver",
  HELPER: "Helper",
}

export const KeyConstants ={
  ASSIGNEE_TYPE: "assigneeType",
  ASSIGNEE_VENDOR: "assigneeVendor",
  ASSIGNEE_NAME: "assigneeName",
  ASSIGNEE_ID: "assigneeId",
  ORDER_CODE: "orderCode",
  CONSIGNMENT_CODE: "consignmentCode",
  DELIVERY_DATE: "deliveryDate",
  TOTAL_ORDER_TIP_AMOUNT: "totalOrderTipAmount",
  TIP_COLLECTED: "tipCollected",
  TOTAL_ORDER_AMOUNT: "totalOrderAmount",
  CONSIGNMENT_STATUS: "consignmentStatus",
  STORE_NAME: "storeName",
  STORE: "store",
  DELIVERED_BY: "deliveredBy",
  PREPARED_BY: "preparedBy",
  HUB_CODE: "hubCode",
  DRIVER: "DRIVER",
  HELPER: "HELPER",
}

const DriversHelperTipConstants = {
  TIP_CONSTANTS: {
    TABLE_WRAPPER_DATA: {
      title: "DriverHelperTip",
      HeaderData: [
        {
          field: KeyConstants.ASSIGNEE_TYPE,
          headerName: TextConstantTip.USER_TYPE,
          width: 120,
        },
        {
          field: KeyConstants.ASSIGNEE_VENDOR,
          headerName: TextConstantTip.VENDOR,
          width: 150,
          filter: true,
          filterObj: {
            type: "autocomplete",
            fieldKey: KeyConstants.ASSIGNEE_VENDOR,
            fieldName: KeyConstants.ASSIGNEE_VENDOR,
            fieldFullName: KeyConstants.ASSIGNEE_VENDOR,
            multiple: true,
            key: `autoComplete-vendor`,
            label: TextConstantTip.VENDOR,
            items: [],
          },
        },
        {
          field: KeyConstants.ASSIGNEE_NAME,
          headerName: TextConstantTip.NAME,
          width: 180,
        },
        {
          field: KeyConstants.ASSIGNEE_ID,
          headerName: TextConstantTip.ID,
          width: 150,
        },
        {
          field: KeyConstants.ORDER_CODE,
          headerName: TextConstantTip.ORDER_ID,
          width: 150,
        },
        {
          field: KeyConstants.CONSIGNMENT_CODE,
          headerName: TextConstantTip.CONSIGNMENT_ID,
          width: 150,
        },
        {
          type: "date",
          field: KeyConstants.DELIVERY_DATE,
          headerName: TextConstantTip.DELIVERY_DATE,
          width: 160,
          filter: true,
          filterObj: {
            type: "dateRange",
            fieldKey: KeyConstants.DELIVERY_DATE,
            fieldName: "dateRange",
            key: `dateRange-filter`,
            placeholderText: TextConstantTip.DELIVERY_DATE,
            label: TextConstantTip.DELIVERY_DATE,
            autoUpdateInput: false,
            autoApply: true,
            showDropdowns: true,
            linkedCalendars: true,
            maxSpan: {
              month: "1",
            },
            locale: {},
          },
        },
        {
          field: KeyConstants.TOTAL_ORDER_TIP_AMOUNT,
          headerName: TextConstantTip.TOTAL_ORDER_TIP,
          width: 150,
        },
        {
          field: KeyConstants.TIP_COLLECTED,
          headerName: TextConstantTip.TIP_SHARE,
          width: 150,
        },
        {
          field: KeyConstants.TOTAL_ORDER_AMOUNT,
          headerName: TextConstantTip.TOTAL_ORDER_AMOUNT,
          width: 150,
        },
        {
          field: KeyConstants.CONSIGNMENT_STATUS,
          headerName: TextConstantTip.STATUS,
          width: 170,
          filter: true,
          filterObj: {
            type: "autocomplete",
            fieldKey: KeyConstants.CONSIGNMENT_STATUS,
            fieldName: KeyConstants.CONSIGNMENT_STATUS,
            fieldFullName: KeyConstants.CONSIGNMENT_STATUS,
            multiple: true,
            key: `autoComplete-delStatus`,
            label: TextConstantTip.STATUS,
            items: [],
          },
        },
        {
          field: KeyConstants.STORE_NAME,
          headerName: TextConstantTip.STORE_NAME,
          width: 170,
        },
        {
          field: KeyConstants.STORE,
          headerName: TextConstantTip.STORE_ID,
          width: 150,
        },
        {
          field: KeyConstants.DELIVERED_BY,
          headerName: TextConstantTip.DELIVERED_BY,
          width: 150,
        },
        {
          field: KeyConstants.PREPARED_BY,
          headerName: TextConstantTip.PREPARED_BY,
          width: 150,
        },
      ],
      headerButtons: [
        {
          name: AppConstants.BUTTONS.DOWNLOAD_ICON,
          displayName: "",
          disabled: false,
          classes: "primary",
          hide: false,
        },
      ],
      loadMore: {
        name: "loadMore",
        disabled: false,
        pageSize: 20,
      },
      defaultFiltersObj: {
        assigneeType: {
          key: KeyConstants.ASSIGNEE_TYPE,
          value: "all",
        },
        assigneeVendor: {
          key: KeyConstants.ASSIGNEE_VENDOR,
          value: [],
        },
        consignmentStatus: {
          key: KeyConstants.CONSIGNMENT_STATUS,
          value: [],
        },
        dateRange: {
          key: "dateRange",
          value: {
            startDate: new Date(),
            endDate: new Date(),
          },
        },
        hubCode: {
          key: KeyConstants.HUB_CODE,
          value: [],
        },
        pageNumber: 0,
      },
      SEARCH_TYPES: [
        {
          name: TextConstantTip.ID,
          value: KeyConstants.ASSIGNEE_ID,
        },
        {
          name: TextConstantTip.NAME,
          value: KeyConstants.ASSIGNEE_NAME,
        },
        {
          name: TextConstantTip.ORDER_ID,
          value: KeyConstants.ORDER_CODE,
        },
        {
          name: TextConstantTip.CONSIGNMENT_ID,
          value: KeyConstants.CONSIGNMENT_CODE,
        },
      ],
      sortModel: {
        field: "id",
        direction: "asc",
      },
      FilterFormData: [
        {
          type: "selectBox",
          fieldName: KeyConstants.ASSIGNEE_TYPE,
          multiple: false,
          enableOnChangeFetch: true,
          key: `selectBox-userType`,
          label: TextConstantTip.USER_TYPE,
          items: [],
        },
      ],
    },
    assigneeTypeDropDown: [
      { name: AppConstants.SELECT_ALL.name, value: AppConstants.SELECT_ALL.value },
      { name: TextConstantTip.DRIVER, value: KeyConstants.DRIVER },
      { name: TextConstantTip.HELPER, value: KeyConstants.HELPER },
    ],
    DRIVER_STATUSES: {
      ACTIVE: {
        color: "OCEAN_GREEN",
        value: "ACTIVE",
        hintText: "",
      },
      AVAILABLE: {
        color: "SEA_GREEN",
        value: "AVAILABLE",
        hintText: "",
      },
      UNASSIGNED: {
        color: "SEA_GREEN",
        value: "UNASSIGNED",
        hintText: "",
      },
      ASSIGNED: {
        color: "GOLDEN_BELL",
        value: "ASSIGNED",
        hintText: "",
      },
      BACK_TO_STORE: {
        color: "INFO_BLUE",
        value: "BACK TO STORE",
        hintText: "",
      },
      AWAY: {
        color: "GREY_SCALE",
        value: "AWAY",
        hintText: "",
      },
      OUT_FOR_DELIVERY: {
        color: "GREY_SCALE",
        value: "OUT FOR DELIVERY",
        hintText: "",
      },
      OFFLINE: {
        color: "GREY_SCALE",
        value: "OFFLINE",
        hintText: "",
      },
    },
    STATUSES: {
      ACTIVE: {
        value: "ACTIVE",
      },
      AVAILABLE: {
        value: "AVAILABLE",
      },
      UNASSIGNED: {
        value: "UNASSIGNED",
      },
      ASSIGNED: {
        value: "ASSIGNED",
      },
      "BACK TO STORE": {
        value: "BACK_TO_STORE",
      },
      AWAY: {
        value: "AWAY",
      },
      "OUT FOR DELIVERY": {
        value: "OUT_FOR_DELIVERY",
      },
      OFFLINE: {
        value: "OFFLINE",
      },
    },

    // uacKey values must match UACConstants.DM_TIPS_ALL/DM_TIPS_EXPRESS/DM_TIPS_STANDARD.
    // Kept as literals (not imported) to avoid a circular import: UACConstants -> constants/index -> DriverHelperTipConstants.
    FILTER_CHIPS: [
      {
        code: "ALL",
        value: "All",
        uacKey: "DM_TIPS_ALL",
      },
      {
        code: "EXP",
        value: "Express",
        uacKey: "DM_TIPS_EXPRESS",
      },
      {
        code: "STD",
        value: "Standard",
        uacKey: "DM_TIPS_STANDARD",
      },
    ],
    DEFAULT_FILTER_CHIP: "ALL",
  },
};

export default DriversHelperTipConstants;
